module.exports = __webpack_public_path__ + "media/svg-new/pesquisa-e490ca64.svg";